export const WorkforceProfile = 'WorkforceProfile/';
export const Evaluate = WorkforceProfile + "Evaluate/"
export const Populate = WorkforceProfile + "Populate/"
export const WorkforceProfileDateLastPopulated = `${WorkforceProfile}DateLastPopulated`;